<template>
  <div>
    <apexchart type="pie" :options="options" :series="series" :width="largura"></apexchart>
    {{preencherGrafico}}
  </div>
</template>
<script>
/* eslint-disable */
import VueApexCharts from "vue-apexcharts";
import Dexie from "dexie";
import ReceitaAnualAbate from "../../class/ReceitaAnualAbate.js";
import ReceitaAnual from "../../class/ReceitaAnual.js";
import BibliotecaDeCalculos from "bibliotecadecalculos-f02";
export default {
  components: {
    apexchart: VueApexCharts
  },
  data: () => ({
    options: {
      legend: {
        position: "top"
      },
      colors: [
        "#BF343F",
        "#A7E4F2",
        "#32736C",
        "#D9B504",
        "#F2811D",
        "#BFBFBF",
        "#A63C76",
        "#128BA6",
        "#F279A6",
        "#590222",
        "#BFBFBF",
        "#D9B504",
        "#F2811D",
        "#A7E4F2",
        "#128BA6"
      ],
      labels: [
        "F 36+ Abate",
        "F 36+",
        "F 24-36 Abate",
        "F 24-36",
        "F 12-24 Abate",
        "F 12-24",
        "F 0-12",
        "M 0-12 ",
        "M 12-24",
        "M 12-24 Abate",
        "M 24-36",
        "M 24-36 Abate",
        "M 36+",
        "M 36+ Abate",
        "Touros"
      ],
      dataLabels: {
        enabled: true,
        formatter: function(val, opts) {
          return (parseFloat(opts.w.config.series[opts.seriesIndex].toFixed(2))).toLocaleString("pt-BR", {style: 'currency', currency: 'BRL'});
        }
      },
      tooltip: {
        y: {
          formatter: function(val) {
            var valor = val
            if(typeof valor !== "undefined")
            {
              return (parseFloat(valor.toFixed(2))).toLocaleString("pt-BR", {style: 'currency', currency: 'BRL'});
            }else 
              return valor
          } 
        }
      }
    },
    series: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
    largura: "100%",
    comprimento: "200%",
    formulario: "",
    simulation: ''
  }),

  mounted() {
    var self = this;
    this.$db.simulation.get(this.$route.params.code, function(s) {
      self.simulation = s;
    });
  },
  computed:{
    preencherGrafico: function() {
      this.$db.simulation.get({ code: this.simulation.code }, dado => {
        var abate = new ReceitaAnualAbate(dado.bovinoAbate);
        var outro = new ReceitaAnual(dado.bovinoOutro);
        var biblioteca = BibliotecaDeCalculos.RebanhoDeVenda(abate, outro);
        return biblioteca;
      })
      .then(
        g => (
          (this.series[0] = g.calculaValorTotalAbate('femea', '36')),
          (this.series[1] = g.calculaValorTotal('femea','36')),
          (this.series[2] = g.calculaValorTotalAbate('femea', '2436')),
          (this.series[3] = g.calculaValorTotal('femea','2436')),
          (this.series[4] = g.calculaValorTotalAbate('femea', '1224')),
          (this.series[5] = g.calculaValorTotal('femea','1224')),
          (this.series[6] = g.calculaValorTotal('femea','012')),
          (this.series[7] = g.calculaValorTotal('macho','012')),
          (this.series[8] = g.calculaValorTotal('macho','1224')),
          (this.series[9] = g.calculaValorTotalAbate('macho', '1224')),
          (this.series[10] = g.calculaValorTotal('macho','2436')),
          (this.series[11] = g.calculaValorTotalAbate('macho', '2436')),
          (this.series[12] = g.calculaValorTotal('macho','36')),
          (this.series[13] = g.calculaValorTotalAbate('macho', '36')),
          (this.series[14] = g.calculaValorTotalTouros())
        )
      );
    }
  }
};
</script>
<style scoped>
</style>
